import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type EwDialogBoxResultType = 'positive' | 'negative' | 'close';
type Color = 'warn' | 'primary' | 'default' | 'accent';

export interface EwDialogBoxData {
  title?: string;
  description: string;
  positiveBtnText: string;
  negativeBtnText: string;
  positiveBtnColor?: Color;
  negativeBtnColor?: Color;
  dialogBoxIcon?: string;
}

@Component({
  selector: 'ew-dialog-box',
  templateUrl: './ew-dialog-box.component.html',
})
export class EwDialogBoxComponent implements OnInit {
 
  constructor(
    private readonly dialogRef: MatDialogRef<
      EwDialogBoxComponent,
      EwDialogBoxResultType
    >,
    @Inject(MAT_DIALOG_DATA) public data: EwDialogBoxData
  ) {
    if(typeof data.dialogBoxIcon === 'undefined'){
      data.dialogBoxIcon = "clear"
    }
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close('close');
  }
  submitResult(result: EwDialogBoxResultType) {
    this.dialogRef.close(result);
  }
}
